export const checkCorrectNumberOfFiles = (
  files: unknown[] | null | undefined,
  numFiles: number,
): boolean => {
  if (!files) {
    return false;
  }

  return files.length >= numFiles;
};

export const checkCorrectFileType = (
  files: { type: string }[] | null | undefined,
): boolean => {
  const SUPPORTED_FORMATS = ['application/pdf'];

  if (!files) {
    return false;
  }

  let isValid = false;
  for (const file of files) {
    if (SUPPORTED_FORMATS.includes(file.type)) {
      isValid = true;
    }
  }

  return isValid;
};
